<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Job Types'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'JobTypeSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [{ header: 'Name', prop: 'name' }, { header: 'Code', prop: 'code' }],
        loading: false,
        tableData: [],
        entityName: 'job-type',
        editEntityScreen: 'Admin - Edit/View Job Type'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// JobTypeSearchResults.vue?31b64550